import { render, staticRenderFns } from "./customLink.vue?vue&type=template&id=f9874eea&scoped=true"
import script from "./customLink.vue?vue&type=script&lang=js"
export * from "./customLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9874eea",
  null
  
)

export default component.exports